<div class="card m-0 p-0 fill">
  <div class="card-body chat-body">
    <div class="feedback-chat-body">
      <div class="row base-shadow-list b-0">
        <div class="col-4 p-l-20 container search-border" *ngIf="!isAnonymousVisible">
          <input
            *ngIf="!isTeammateMode"
            type="text"
            class="borderless feedback-chat-header-element"
            [disabled]="isTeammateMode"
            [(ngModel)]="searchString"
            (keyup)="searchContactIfRequired()"
            placeholder="{{ 'lang.common.search' | translate }}"
          />
          <div *ngIf="isTeammateMode" class="container pm-anonym-checkbox">
            <input
              id="anonymForPMCheckbox"
              type="checkbox"
              class="borderless feedback-chat-header-element"
              [checked]="isAnonymousVisible"
              (change)="setAnonymity(!isAnonymousVisible)"
            />
            <label for="anonymForPMCheckbox">{{ 'lang.common.anonymous' | translate }}</label>
          </div>
        </div>
        <div class="col-8 container head-conversation" *ngIf="!isAnonymousVisible">
          <div *ngIf="activeChatParticipant" class="companion-holder chat-nameholder">
            {{
              currentChatParticipant.isActive ? currentChatParticipant.displayName : ('lang.common.leaver' | translate)
            }}
          </div>
        </div>
        <div class="col-12 container head-conversation" *ngIf="isAnonymousVisible">
          <div class="companion-holder chat-nameholder feedback-chat-header-element">
            {{ 'lang.common.anonymous' | translate }}
          </div>
        </div>

        <div class="col-12 container">
          <div class="row">
            <div class="chat-wrap col-4" *ngIf="!isAnonymousVisible">
              <div *ngIf="isSearchingReady">
                <div *ngFor="let chat of searchChats" class="contact">
                  <div class="media chat" [ngClass]="{ 'chat-choosen': checkChosenChat(chat) }" (click)="getChat(chat)">
                    <a class="pull-left chat-img">
                      <img
                        class="media-object img-circle img-contact"
                        data-src="holder.js/64x64"
                        alt=" "
                        [src]="chat.employeePhoto ? chat.employeePhoto : defaultPhoto"
                      />
                    </a>
                    <div class="media-body contact-container">
                      <div class="media-heading chat-nameholder">
                        {{ chat.displayName }}
                      </div>
                      <div class="inactive-text">
                        {{ chat.position }}
                      </div>
                      <div class="inactive-text">
                        {{ chat.businessUnit }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="!isSearchingReady">
                <div *ngFor="let chat of chatParticipants" class="contact">
                  <div
                    class="media chat"
                    [ngClass]="{
                      'chat-choosen': checkChosenChat(chat) && !isAnonymousVisible
                    }"
                    (click)="getChat(chat)"
                  >
                    <a class="pull-left chat-img">
                      <img
                        *ngIf="chat.isActive"
                        class="media-object img-circle img-contact"
                        data-src="holder.js/64x64"
                        alt=" "
                        [src]="chat.employeePhoto ? chat.employeePhoto : defaultPhoto"
                      />
                      <div [class.user-leaver]="!chat.isActive"></div>
                    </a>
                    <div class="media-body contact-container">
                      <div class="media-heading chat-nameholder">
                        <span *ngIf="chat.isActive">{{ chat.displayName }}</span>
                        <span *ngIf="!chat.isActive">
                          {{ 'lang.common.leaver' | translate }}
                        </span>
                      </div>
                      <div class="inactive-text">
                        {{ chat.position }}
                      </div>
                      <div class="inactive-text">
                        {{ chat.businessUnit }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="message-wrap" [ngClass]="isAnonymousVisible ? 'col-12' : 'col-8'">
              <div
                slimScroll
                width="auto"
                height="436px"
                size="3px"
                alwaysVisible="true"
                autoScrollToBottom="true"
                class="container msg-wrap"
                #scrollChat
              >
                <div *ngIf="activeChatParticipant" [class.align-center]="isAnonymousVisible">
                  <div
                    *ngFor="let message of activeChatParticipant.messages"
                    [ngClass]="{
                      'msg-mine': checkMineMessage(message.feedbackChatParticipantId),
                      'msg-contact': !checkMineMessage(message.feedbackChatParticipantId),
                      'msg-anon': isAnonymousVisible,
                      'message-selected': message.id === selectedMessageId
                    }"
                    class="media msg"
                    (click)="selectMessageToAction(message)"
                  >
                    <a
                      *ngIf="!checkMineMessage(message.feedbackChatParticipantId) && !isAnonymousVisible"
                      class="pull-left image-companion chat-img"
                    >
                      <img
                        *ngIf="message.isActive"
                        class="media-object img-circle"
                        data-src="holder.js/64x64"
                        alt=" "
                        [src]="getActivePhoto(message.feedbackChatParticipantId)"
                      />
                      <div
                        *ngIf="activeChatParticipant && !isAnonymousVisible && !message.isActive"
                        [class.user-leaver-chat]="!message.isActive"
                      ></div>
                    </a>
                    <div class="media-body media-container" [class.no-max-width]="isAnonymousVisible">
                      <small
                        [class.received-date-view]="!checkMineMessage(message.feedbackChatParticipantId)"
                        class="pull-right date"
                        [class.received-date-view-anonymous]="isAnonymousVisible"
                      >
                        <i class="fa fa-clock-o"></i>
                        {{ localeTime(message.createdDate) }}
                      </small>
                      <div class="companion-name">
                        <span *ngIf="message.isActive">{{ message.displayName }}</span>
                        <span class="d-none" [class.title-anonym]="message.anonymously"
                          >({{ 'lang.common.anonym' | translate }})</span
                        >
                        <span *ngIf="activeChatParticipant && !isAnonymousVisible && !message.isActive">
                          {{ 'lang.common.leaver' | translate }}
                        </span>
                      </div>
                      <div class="msg-text detail-text" [class.msg-text-anon]="message.anonymously">
                        {{ message.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="input-group imput-message-form"
                *ngIf="!isMessageSelected && !isTeammateMode && !isAnonymousVisible && currentChatParticipant"
              >
                <textarea
                  id="btn-input"
                  [(ngModel)]="sendMessageText"
                  [disabled]="isAnonymousVisible || isTeammateMode"
                  class="input-sm input-message borderless col-7"
                  placeholder="{{ 'lang.chat.placeholder.messageInput' | translate }}"
                  (keyup.enter)="sendMessage(currentChatParticipant)"
                  #messageInput
                ></textarea>
                <div class="col-5 pl-0 text-right">
                  <span class="input-group-btn text-right">
                    <div #emojiPopup *ngIf="canShowEmojiPanel">
                      <emoji-mart
                        [isNative]="true"
                        [hideObsolete]="true"
                        [enableSearch]="false"
                        [showPreview]="false"
                        emojiSize="20"
                        [emojisToShowFilter]="filterEmoji"
                        [include]="emojiIncludeCategories"
                        [style]="emojiPanelStyle"
                        (emojiClick)="selectEmoji($event)"
                      ></emoji-mart>
                    </div>
                    <span class="emoji">
                      <span #emojiSelect class="emoji-select" (click)="toggleEmojiPanel()">😃</span>
                    </span>
                    <span>
                      <input
                        type="checkbox"
                        checked
                        id="checkbox1"
                        [(ngModel)]="isAnonymousMessage"
                        [disabled]="isAnonymousVisible || isTeammateMode"
                      />
                      <label for="checkbox1">
                        {{ 'lang.common.anonymously' | translate }}
                      </label>
                    </span>
                    <button
                      class="btn btn-warning btn-sm btn-submit"
                      id="btn-chat"
                      [disabled]="isAnonymousVisible || isTeammateMode"
                      (click)="sendMessage(currentChatParticipant)"
                    >
                      {{ 'lang.common.btn.send' | translate }}
                    </button>
                  </span>
                </div>
              </div>
              <div *ngIf="isMessageSelected" class="input-group imput-message-form row message-controll-panel">
                <div class="col-5"></div>
                <a class="btn" (click)="openApproveModal(approveModal)">
                  <i class="icon-trash"></i>
                  <strong> {{ 'lang.common.btn.delete' | translate }}</strong>
                </a>
                <a class="btn" (click)="unselectMessageToAction()">
                  <i class="icon-align-justify"></i>
                  <strong> {{ 'lang.common.btn.cancel' | translate }}</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #approveModal>
  <div>
    <div class="modal-body">
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="d-flex justify-content-center flex-column" style="min-height: 85px">
        <div>
          {{ 'lang.common.warning.deleteMessage' | translate }}
        </div>
      </div>
      <div class="btn-modal">
        <span (click)="deleteMessage()">{{ 'lang.common.btn.yes' | translate }}</span>
        <span (click)="modalRef.hide()">{{ 'lang.common.btn.cancel' | translate }}</span>
      </div>
    </div>
  </div>
</ng-template>
